import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { selectProgramType } from 'legacy/lut/features/partner360/configuration'
import { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { LocationCompatible } from 'shared/lib/location'

interface IUseInitialData {
  handleShowNewDialog: () => void
}

export const useNewKeyInitiative = <T>({ handleShowNewDialog }: IUseInitialData) => {
  const [sourceItem, setSourceItem] = useState<T>()

  const programType = useSelector(selectProgramType)

  const navigate = useNavigate()

  const isRetail = programType === ProgramTypes.Retail

  useEffect(() => {
    const locationCompatible = LocationCompatible.getLocation()
    const urlParams = new URLSearchParams(locationCompatible.search)
    const openKIForm = urlParams.get('openKIForm')

    if (openKIForm) {
      setSourceItem((prev) => {
        if (prev) {
          return {
            ...prev,
            DataInsightRelated: isRetail ? 1 : 0,
          }
        }

        return {
          DataInsightRelated: isRetail ? 1 : 0,
        } as T
      })
      handleShowNewDialog()
      locationCompatible.search = ''
      LocationCompatible.setLocation(locationCompatible)
      navigate(locationCompatible, { replace: true })
    }
  }, [isRetail, navigate, handleShowNewDialog])

  const resetSourceItem = useCallback(() => {
    setSourceItem(undefined)
  }, [])

  return { sourceItem, setSourceItem, resetSourceItem }
}
